import classNames from 'classnames';
import React, { memo, forwardRef } from 'react';
import { makeStyles } from 'tss-react/mui';

import CircularProgress from '@mui/material/CircularProgress';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'center',
    height: '100%',
  },
  progress: {
    color: theme.palette.primary.main,
    margin: 20,
  },
  roundedEdge: {
    '& .MuiCircularProgress-circle': {
      strokeLinecap: 'round',
    },
  },
}));

type LoadingProps = {
  size?: number;
  style?: object;
  circularProgressStyle?: object;
  children?: React.ReactNode;
  title?: string;
  subTitle?: string;
  thickness?: number;
  roundedEdge?: boolean;
  id?: string;
  in?: boolean;
  className?: string | object;
};

const LoadingView = forwardRef((props: LoadingProps, ref: any) => {
  const { size = 40, style, circularProgressStyle, roundedEdge, thickness, in: show = true, className } = props;

  const { classes, cx } = useStyles();

  return (
    <Fade in={show} timeout={800} mountOnEnter unmountOnExit>
      <div ref={ref} className={classNames(classes.root, className)} style={style} id={props.id}>
        <CircularProgress
          id='loading-spinner'
          thickness={thickness}
          className={cx(classes.progress, ...(roundedEdge ? [classes.roundedEdge] : []))}
          size={size}
          style={circularProgressStyle}
        />

        {props.title && <Typography variant='titleMedium'>{props.title}</Typography>}

        {props.subTitle && <Typography variant='bodyMedium'>{props.subTitle}</Typography>}

        {props.children}
      </div>
    </Fade>
  );
});

LoadingView.displayName = 'LoadingView';

export default memo(LoadingView);
